export function isSameDomain(url: unknown): boolean | undefined {
    if (typeof url === 'string') {
        const urlParser = new URL(url, window.location.href);
        return urlParser.origin === window.location.origin;
    }
}
